import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { User, KeyRound, Mail, Globe, LogOut, ArrowUpRight, ShoppingBag, Shield, MessageCircle } from 'lucide-react';
import { logoutUser } from '../store/userSlice';
import PageHeading from './PageHeading';
import LanguageSwitcher from './LanguageSwitcher';
import LoginModal from './LoginModal';

export default function SettingsPage() {
  const { user, isLoggedIn } = useSelector((state) => state.user);
  const [loginOpen, setLoginOpen] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div className="page-shell">
      <PageHeading Icon={User} eyebrow="ACCOUNT · 我的账号" title="账号设置" description="查看账号信息，管理登录密码和界面语言。" />
      {!isLoggedIn ? (
        <div className="page-card text-center py-12">
          <img src="/images/logo.jpg" alt="大师兄 Logo" width="72" height="72" className="mx-auto mb-4" />
          <h2 className="text-xl font-bold mb-2">登录后，管理你的账号</h2>
          <p className="text-sm text-muted mb-6">查看订单、管理账号信息，随时找到购买记录。</p>
          <button onClick={() => setLoginOpen(true)} className="brand-purchase">登录 / 注册</button>
        </div>
      ) : (
        <div className="grid md:grid-cols-[1fr_1.5fr] gap-5">
          <section className="page-card">
            <span className="page-icon mb-5"><User /></span>
            <h2 className="text-xl font-bold break-all">{user?.name || user?.email || '我的账号'}</h2>
            <p className="text-sm text-muted mt-2 break-all">账号 ID：{user?.uid || user?.id || '—'}</p>
            <Link to="/orders" className="page-secondary mt-6"><ShoppingBag size={18} />查看历史订单</Link>
          </section>
          <section className="page-card">
            <h2 className="text-lg font-bold">账号与安全</h2>
            <div className="page-row"><Mail size={20} className="text-brand shrink-0" /><div><strong className="text-sm">邮箱地址</strong><p>{user?.email || '未提供邮箱'}</p></div></div>
            <Link to="/change-password" className="page-row"><KeyRound size={20} className="text-brand shrink-0" /><div><strong className="text-sm">修改登录密码</strong><p>更新此网站账号的登录密码。</p></div><ArrowUpRight size={18} /></Link>
            <button onClick={() => setLogoutOpen(true)} className="page-row w-full text-left"><LogOut size={20} className="text-muted" /><div><strong className="text-sm">退出登录</strong><p>退出当前账号，稍后可重新登录。</p></div></button>
          </section>
        </div>
      )}
      <section className="page-card mt-5">
        <div className="flex items-center justify-between flex-wrap gap-5"><div className="flex items-center gap-3"><Globe size={20} className="text-brand" /><div><h2 className="font-bold">界面语言</h2><p className="text-sm text-muted">选择你的显示语言。</p></div></div><LanguageSwitcher className="header-language-switcher" /></div>
      </section>
      <div className="flex flex-wrap gap-5 mt-7 text-sm text-muted"><Link to="/customer-service" className="flex gap-2 items-center hover:text-brand"><MessageCircle size={16} />联系客服</Link><Link to="/privacy" className="flex gap-2 items-center hover:text-brand"><Shield size={16} />隐私政策</Link></div>
      {logoutOpen && <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="logout-title"><div className="responsive-dialog-panel page-card max-w-sm w-full"><h2 id="logout-title" className="text-xl font-bold mb-3">退出当前账号？</h2><p className="text-sm text-muted mb-6">重新登录后可以继续查看订单。</p><div className="flex gap-3"><button autoFocus onClick={() => setLogoutOpen(false)} className="page-secondary flex-1">取消</button><button onClick={() => { dispatch(logoutUser()); navigate('/'); }} className="brand-purchase flex-1">退出登录</button></div></div></div>}
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} onLogin={() => setLoginOpen(false)} />
    </div>
  );
}
